import { NgModule } from "@angular/core";
import { ReceptionMarchandiseFormComponent } from './reception-marchandise-form/reception-marchandise-form.component';
import { DynamicReceptionMarchandiseComponent } from './dynamic-reception-marchandise.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { ReceptionMarchandiseDesignComponent } from './reception-marchandise-design/reception-marchandise-design.component';
import { ReceptionMarchandiseResultComponent } from './reception-marchandise-result/reception-marchandise-result.component';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { ReceptionMarchandiseService } from './reception-marchandise.service';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CodeScannerModule } from '../../code-scanner/code-scanner.module';
import { MatCardModule } from '@angular/material/card';
import { DropdownModule } from '../../dropdown/dropdown.module';
import { FamocoScanLaserModule } from '../../famoco-scan-laser/famoco-scan-laser.module';
import { KendoModule } from '../../kendo.module';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    declarations: [
        ReceptionMarchandiseResultComponent,
        ReceptionMarchandiseDesignComponent,
        ReceptionMarchandiseFormComponent, DynamicReceptionMarchandiseComponent,
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        MatIconModule,
        MatButtonModule,
        MatProgressSpinnerModule,
        MatCardModule,
        MatFormFieldModule,
        MatSelectModule,
        CodeScannerModule,
        DropdownModule,
        FamocoScanLaserModule,
        KendoModule
    ],
    entryComponents: [
        DynamicReceptionMarchandiseComponent,
    ],
    providers: [
        ReceptionMarchandiseService
    ]
})
export class ReceptionMarchandiseModule {}